import {
  MembershipPeriodApi,
  RenewalApi,
} from 'api-typings/memberships/memberships_types';
import { transformDuration } from '../membership-subscription-history/membership-subscription-history.transformers';
import {
  MembershipPeriod,
  MembershipRenewal,
} from './membership-renewals.model';

export function transformMembershipRenewal(
  membershipRenewal: RenewalApi,
): MembershipRenewal {
  return {
    id: membershipRenewal.id,
    period: transformMembershipPeriod(membershipRenewal.period),
    timeOptedIn: membershipRenewal.time_opted_in * 1000,
    timeOptedOut: membershipRenewal.time_opted_out
      ? membershipRenewal.time_opted_out * 1000
      : undefined,
    duration: transformDuration(membershipRenewal.duration),
    failureCount: membershipRenewal.failure_count,
  };
}

export function transformMembershipPeriod(
  membershipPeriod: MembershipPeriodApi,
): MembershipPeriod {
  return {
    id: membershipPeriod.id,
    packageId: membershipPeriod.package_id,
    userId: membershipPeriod.user_id,
    timeStarted: membershipPeriod.time_started * 1000,
    timeEnded: membershipPeriod.time_ended
      ? membershipPeriod.time_ended * 1000
      : undefined,
  };
}
